module.exports = __webpack_public_path__ + "img/elementlengths_jasa.4b4923e2.png";